import { useState, useMemo, useEffect, useRef } from "react";

import LeftMenu from "../../../Components/Layout/LeftMenu";
import Header from "../../../Components/Layout/Header";
import '../../../assets/css/s_recovery/s_recovery.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark, faArrowLeft, faArrowRight, faSave, faDownload, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { Button, Row, Col, Form, Modal } from 'react-bootstrap';
import { Step, StepLabel, Stepper } from '@mui/material';
import Select from 'react-select'
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import { ReactComponent as DbIcon } from "../../../assets/images/sidebar/planning.svg";
import { ReactComponent as OvIcon } from "../../../assets/images/icon_svg/Overview_icon.svg";
import { ReactComponent as InboxIcon } from "../../../assets/images/sidebar/inbox.svg";
import { ReactComponent as TmIcon } from "../../../assets/images/sidebar/task.svg";
import { ReactComponent as IvIcon } from "../../../assets/images/sidebar/invoice.svg";

import { ReactComponent as ChartIcon } from "../../../assets/images/sidebar/chart.svg";
import { ReactComponent as ExdIcon } from "../../../assets/images/sidebar/exp_doc.svg";
import { ReactComponent as SettingsIcon } from "../../../assets/images/sidebar/settings.svg";
import { ReactComponent as ManualIcon } from "../../../assets/images/sidebar/manual.svg";
import { ReactComponent as SaveIcon } from "../../../assets/images/save.svg";
import { ReactComponent as AddIcon } from "../../../assets/images/add.svg";

import { ReactComponent as Awb } from "../../../assets/images/icon_svg/pieceee.svg";
import { ReactComponent as Crtical } from "../../../assets/images/icon_svg/error.svg";
import { ReactComponent as Non_Compliance } from "../../../assets/images/icon_svg/Non_Compliance.svg";
import { ReactComponent as New_upload } from "../../../assets/images/icon_svg/new_upload.svg";

import records from '../../../assets/images/recovery_dahboard/records.svg';
import info from '../../../assets/images/recovery_dahboard/info.svg';
import critical from '../../../assets/images/recovery_dahboard/star.svg';
import newrecords from '../../../assets/images/recovery_dahboard/record_new.svg';
import Rsetting from "../../../assets/images/rsettings.png";
import Offline from "../../../assets/images/offline.png";
import add from "../../../assets/images/add.svg";
import feather_upload_cloud from "../../../assets/images/feather_upload_cloud.svg";
import delete_icon from "../../../assets/images/delete.svg";
import MailGreen from '../../../assets/images/mail_green.png';
import MailRed from '../../../assets/images/mail_red.png';
import Trash from '../../../assets/images/gray_delete.svg';

import { ReactComponent as GS } from "../../../assets/images/settings_icon/settings.svg";
import { ReactComponent as DS } from "../../../assets/images/settings_icon/resourcesettings.svg";
import { ReactComponent as SS } from "../../../assets/images/settings_icon/plane.svg";
import { ReactComponent as RS } from "../../../assets/images/settings_icon/region.svg";
import { ReactComponent as DtS } from "../../../assets/images/settings_icon/resourcesettings.svg";
import { ReactComponent as RaS } from "../../../assets/images/settings_icon/assign.svg";
import { ReactComponent as TmM } from "../../../assets/images/settings_icon/template.svg";
import { ReactComponent as Search } from "../../../assets/images/icon_svg/asr_search.svg";

import CommonCard from "../../../Components/common/CommonCard";
import Dashboard from "./Dashboard";
// import Overview from "./Overview";
import { CallApi, CommonModal } from "../../../Components/common/CommonFunctions";
import SettingsNew from "../../Settings/SettingsNew";
import { GETDESTINATION, GETOWNERCODE, GETSHC, SAVEHANDLER, STATIONHANDLER, STATIONLIST } from "../../../Utils/conts";
import OvDetails from "./OvDetails";
import Export from "./Export";
import Charts from "./Charts";
import ChartGenerator from "./ChartGenerator";
import { DownloadImage } from "../../../Components/common/DownloadImage";
import { useV2DropdownListQuery } from "../../../redux/services/SRC";
import CriticalDiscrepancies from "./CriticalDiscrepancies";
import GeneralDiscrepancies from "./GeneralDiscrepancies";
import NonCompliance from "./NonCompliance";
import { useUserCheckQuery } from "../../../redux/services/Auth";


const ServiceRecovery = () => {

    const initialTab = localStorage.getItem("MainTab");
    const initPage = localStorage.getItem("InnerPage");
    const [mainTab, setMainTab] = useState(initialTab || 'DB');
    const initialSub = localStorage.getItem("SubTab");
    const [subTab, setSubTab] = useState(initialSub || '');
    const initTitle = {
        title: 'Service Recovery',
        search: {
            placeholder: 'Search AWB Number',
            endPoint: 'v2/service-recovery/recovery-information',
            fieldName: 'master_airway_bill',
            payload: { global_search: 1 },
            onResponse: {},
            icon: <Search />
        }
    }
    const [sendHeader, setSendHeader] = useState(initTitle);
    const [extraHeader, setExtraHeader] = useState([]);
    const [innerPage, setInnerPage] = useState(initPage || '');
    // Modal Init
    const isMounted = useRef(false);

    const [searchModal, setSearchModal] = useState(false);
    const [getShc, setGetShc] = useState([]);
    const [getOwnerCodes, setGetOwnerCode] = useState([]);
    const [multiDropDown, setMultiDropDown] = useState({});
    const initFData = { all_routing: [], }
    const [formData, setFormData] = useState({});
    const [duplicateData, setDuplicateData] = useState([]);

    const [getDestination, setGetDestination] = useState([]);
    const [handlerList, setHandlerList] = useState([]);

    const [originHandler, setOriginHandler] = useState([]);
    const [selectedOriginId, setSelectedOriginId] = useState(null);
    const [selectedOriginHandler, setSelectedOriginHandler] = useState(null);

    const [destinationHandler, setDestinationHandler] = useState([]);
    const [selectedDestinationId, setSelectedDestinationId] = useState(null);
    const [selectedDestinationHandler, setSelectedDestinationHandler] = useState(null);

    const [reportHandler, setReportHandler] = useState([]);
    const [selectedReportHandler, setSelectedReportHandler] = useState(null);
    const [reportId, setrReportId] = useState(null);

    const [inputAddress, setInputAddress] = useState({
        handler_org_id: '', address: '', handler_email_id: '', handler_phone_no: ''
    });
    const [addressFor, setAddressFor] = useState('');
    const [selectedStation, setSelectedStation] = useState({});
    const [addressModalShow, setAddressModalShow] = useState(false);
    const addressModalClose = () => { setAddressModalShow(false); setInputAddress({ handler_org_id: '', address: '', handler_email_id: '', handler_phone_no: '' }) }
    const [address, setAddress] = useState([]);
    const [stations, setStations] = useState([]);
    const [onReload, setOnReload] = useState(false);
    const [preLoader, setPreLoader] = useState(false);

    // IMAGE UPLOAD START
    const fileInputRef = useRef(null);
    const [isTopDel, setIsTopDel] = useState(false);
    const [files, setFiles] = useState([]);
    const [editFiles, setEditFiles] = useState([]);
    const [base64Files, setBase64Files] = useState([]);
    const [isError, setIsError] = useState(null);

    const [userDetails, setUserDetails] = useState();
    // IMAGE UPLOAD End

    // const [v2DropdownList] = useV2DropdownListMutation();
    // const fetchDrop = async () => {
    //     try {
    //         const res = await v2DropdownList({}).unwrap();

    //         const innerData = res?.response_data;
    //         setMultiDropDown(innerData);
    //     } catch (error) {
    //         console.error(error);
    //     }
    // };
    const { data: dropData } = useV2DropdownListQuery();
    useEffect(() => {
        if (dropData?.response_data) {
            setMultiDropDown(dropData.response_data);
        }
    }, [dropData]);

    const { data: myData } = useUserCheckQuery('', {
        // skip: pageDetails.pagesize === 0,
    });
    useEffect(() => {
        if (myData?.response_data) {
            setUserDetails(myData?.response_data);
        }
    }, [myData]);

    const fetchSHC = async () => {
        CallApi({
            endPoint: GETSHC,
            onSuccess: (res) => {
                const innerData = res.data.response_data;
                const transformedData = innerData ? innerData.map(item => ({
                    value: item.code,
                    label: item.code,
                })) : [];
                setGetShc(transformedData);
            },
            onError: (msg) => console.error(msg)
        });
    };
    const fetchStationData = async () => {
        CallApi({
            endPoint: STATIONLIST,
            onSuccess: (res) => {
                const innerData = res.data.response_data;
                const transformedData = innerData ? innerData.map(item => ({
                    value: item.port_code,
                    label: item.port_code,
                    address: item.address,
                    station_id: item.station_id
                })) : [];
                setGetDestination(transformedData);
                // setDisLoading(false);
            },
            onError: (msg) => console.error(msg)
        });
    };

    const fetchOwnerCode = async () => {
        CallApi({
            endPoint: GETOWNERCODE,
            onSuccess: (res) => {
                const innerData = res.data.response_data;
                const transformedData = innerData ? innerData.map(item => ({
                    value: item.IATA,
                    label: item.IATA
                })) : [];
                setGetOwnerCode(transformedData);
            },
            onError: (msg) => console.error(msg)
        });
    };
    const fetchAddressData = async (id = 1, stn) => {
        const payload = {
            stationId: ['report', 'RH'].includes(id) ? selectedOriginId : ['destination', 'DH'].includes(id) ? selectedDestinationId : stn.station_id
        }
        CallApi({
            endPoint: STATIONHANDLER,
            payload: payload,
            onSuccess: (res) => {
                const innerData = res.data.response_data;
                const transformedData = innerData ? innerData.map(item => ({
                    value: item.handler_org_id,
                    label: item.org_name,
                    email: item.handler_email_id
                })) : [];
                setHandlerList(transformedData);
            },
            onError: (msg) => console.error(msg)
        });
    };
    // Modal Init

    const [isIconClosed, setIsIconClosed] = useState(true);

    const sections = ['main', 'report', 'settings'];
    const navItems = {
        home: true,
        button: {
            name: 'Create New',
            icon: 'addIcon',
            cls: 'w-100 mt-0',
            sub: [
                { name: 'Irregularity Case', value: 'IC', icon: <> <Crtical /> </> },
                { name: 'Non Compliance', value: 'NC', icon: <> <Non_Compliance /> </> },
            ]
        },
        main: [
            { path: 'DB', name: 'Dashboard', heading: 'Dashboard', icon: <DbIcon className='menu-icon' /> },
            // { path: 'OV', name: 'Overview', heading: 'Overview', icon: <OvIcon className='menu-icon' /> },
            { path: 'CD', name: 'Critical Discrepancies', heading: 'Critical Discrepancies', icon: <Crtical className='menu-icon' /> },
            { path: 'GD', name: 'General Discrepancies', heading: 'General Discrepancies', icon: <Awb className='menu-icon' /> },
            { path: 'NC', name: 'Non Compliance', heading: 'Non Compliance', icon: <Non_Compliance className='menu-icon' /> },

            // { path: 'TM', name: 'Task Management', heading: 'Task Management', uc: true, icon: <TmIcon className='menu-icon' /> },
            // { path: 'IN', name: 'Inbox', heading: 'Inbox', uc: true, icon: <InboxIcon className='menu-icon' /> },
            // { path: 'IV', name: 'Invoicing', heading: 'Invoicing', uc: true, icon: <IvIcon className='menu-icon' /> },
        ],
        report: [
            {
                path: 'KC', name: 'KPI Charts', heading: 'KPI Charts', icon: <ChartIcon className='menu-icon' />,
                sub: [
                    { path: 'CDB', name: 'Dashboard', heading: 'Dashboard', default: true },
                    { path: 'CG', name: 'Chart Generator', heading: 'Chart Generator', },
                ]
            },
            { path: 'EXP', name: 'Export', icon: <ExdIcon className='menu-icon' /> },
        ],
        settings: [
            { path: 'ST', name: 'Settings', heading: 'Settings', icon: <SettingsIcon className='menu-icon' /> },
            { path: 'ML', name: 'Manual', module: 'ASR', dName: 'Manual-Service-Recovery-English.pdf', icon: <ManualIcon className='menu-icon' /> },
        ]
    };
    const settingsNav = [
        {
            name: 'General',
            settingsSearch: true,
            items: [
                { name: 'General', path: '#', icon: <GS />, tab: 'asr_gen', default: true },
            ]
        },
        {
            name: 'Operations',
            items: [
                { name: 'Stations', icon: <SS />, tab: 'asr_stn' },
                { name: 'Regions', icon: <RS />, tab: 'asr_rgn' },
                // { name: 'File Management', icon: <RS />, tab: 'asr_fmt' },
                // { name: 'Addressbook', icon: <RS />, tab: 'asr_addr' },
            ]
        },
        {
            name: 'Access',
            items: [
                { name: 'Region Access', icon: <DtS />, tab: 'asr_rac' },
                // { name: 'Permissions', icon: <DtS />, tab: 'asr_prn' },
            ]
        },
        {
            name: 'Automation',
            items: [
                { name: 'Region Assignment', icon: <RaS />, tab: 'asr_ras' },
                { name: 'Template Manager', icon: <TmM />, tab: 'asr_tmr' },
            ]
        },
    ];

    const handleCollapse = (value) => {
        setIsIconClosed(value);
    };

    useEffect(() => {
        if (isMounted.current) return;
        // if (modalShow) {

        // }
        fetchSHC();
        fetchStationData();
        fetchOwnerCode();
        // fetchDrop()
        isMounted.current = true;
        // const findRow = navItems?.main?.find(i => i.path === mainTab)
        const findRow = sections.flatMap(section => navItems?.[section] || []).find(i => i.path === mainTab);
        // setSubHead(findRow?.heading || findRow?.name)
        setSendHeader({
            ...initTitle,
            subTitle: findRow?.heading || findRow?.name
        });

    }, [])

    const handleNavClick = (main = null, page = '', extraInfo, filter) => {

        if (!filter) {
            localStorage.removeItem('PreFilter')
        }
        setExtraHeader([])
        if (page) {
            setInnerPage(page);
            localStorage.setItem('InnerPage', page);
            localStorage.setItem('DetailsTitle', extraInfo);
            setSendHeader({
                ...initTitle,
                subTitle: page === 'OVD' ? 'Overview' : '',
                extraInfo: extraInfo,
            });
        }
        if (main) {
            setInnerPage('');
            localStorage.setItem('InnerPage', '');
            localStorage.removeItem('DetailsTitle');
            setOnReload(false)

            setMainTab(main.path);
            if (main.sub) {
                if (!initialSub) {
                    const findDefault = main?.sub?.find(i => i.default)
                    setSubTab(findDefault?.path)
                    localStorage.setItem('SubTab', findDefault?.path)
                    // setSubHead(findDefault?.heading)
                    setSendHeader({
                        ...initTitle,
                        subTitle: findDefault?.heading
                    });
                } else {
                    setSubTab(initialSub)
                }
            } else {
                const findRow = sections.flatMap(section => navItems?.[section] || []).find(i => i.path === main.path);
                // setSubHead(findRow?.heading || findRow?.name)
                setSendHeader({
                    ...initTitle,
                    subTitle: findRow?.heading || findRow?.name
                });


                if (main.path === 'OV') {
                    fetchSHC();
                    fetchStationData();
                    fetchOwnerCode();
                    // fetchDrop()
                }
            }
            localStorage.setItem('MainTab', main.path);
        }
    }

    const handleSubNav = (snav) => {
        // console.log('snav', snav);
        if (snav) {
            setSubTab(snav?.path)
            localStorage.setItem('SubTab', snav?.path)
            // setSubHead(snav?.heading)
            setSendHeader({
                ...initTitle,
                subTitle: snav?.heading
            });
        }
    }

    const [isLoading, setIsLoading] = useState(false);
    const [modalShow, setModalShow] = useState(false)
    const [modalPos, setModalPos] = useState('')
    const [errorType, setErrorType] = useState([])
    const [editModal, setEditModal] = useState(false)
    const [activeStep, setActiveStep] = useState(0)
    const fetchErrorType = async () => {
        CallApi({
            endPoint: 'v2/non-compliance/dropdown-list',
            onSuccess: (res) => {
                const innerData = res.data.response_data.compliance_type_of_error;
                setErrorType(innerData || []);
            },
            onError: (msg) => console.error(msg)
        });
    };
    const addRecord = (pos) => {
        setModalPos(pos)
        if (pos === 'IC') {
            setOnReload(false)
            fetchRecoveryInformation(null, pos)
            setrReportId(null)
            // setFormData(initFData)
            // fetchSHC();
            // fetchStationData();
            // fetchOwnerCode();
            // fetchDrop()


        } else {
            fetchErrorType()
            setFormData({})
        }
        setModalShow(true)
    }

    const recAction = (val) => {
        if (val === 'AWB') {
            fetchRecoveryInformation(null, 'NC')
        } else {
            const { reference_value, awb_prefix, awb_no, ...rest } = formData
            setFormData({ ...rest, reference_type: val });
        }
    }
    const handleNcChange = (e) => {
        const { name, value, checked } = e.target;
        // if (name === 'master_airway_bill_no') {
        //     const newValue = handleChange(value);
        //     setFormData(prev => ({
        //         ...prev,
        //         // master_airway_bill_no: newValue
        //         master_airway_bill_no: value
        //     }));
        // } else {
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // }

    }
    const validateNc = () => {

        if (formData?.reference_type === 'AWB') {
            if (!formData.awb_prefix) {
                toast.error("Please Add Master Airway Bill Prefix");
                return;
            } else {
                const isValidPrefix = /^\d{3}$/.test(formData.awb_prefix);
                if (!isValidPrefix) {
                    toast.error("Master Airway Bill Prefix must be 3 digits");
                    return;
                }
            }
            if (!formData.awb_no) {
                toast.error("Please Add Master Airway Bill Number");
                return;
            } else {
                const isValidPrefix = /^\d{8}$/.test(formData.awb_no);
                if (!isValidPrefix) {
                    toast.error("Master Airway Bill Number must be 8 digits");
                    return;
                }
            }
        }

        return true;
    }
    const saveNc = () => {
        if (!validateNc()) return;
        let payLoad = {};
        if (formData?.reference_type === 'AWB') {
            const refn = { reference_value: formData.awb_prefix + '-' + formData.awb_no, ...formData }
            const { awb_no, awb_prefix, ...rest } = refn;
            payLoad = rest
        } else {
            payLoad = formData
        }

        CallApi({
            endPoint: 'v2/non-compliance/save',
            payload: payLoad,
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    toast.success('Record Saved Successfully');
                    if (mainTab === 'NC') {
                        setOnReload(true);
                    }
                    handleModalClose()
                } else {
                    toast.error(res.data.response_msg)
                }
            },
            onError: (msg) => console.error(msg)
        });
    }

    const ncEdit = (id) => {
        setIsLoading(true)
        CallApi({
            endPoint: 'v2/non-compliance/details',
            payload: { id: id },
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    fetchErrorType()
                    const innerData = res.data.response_data;
                    if (innerData?.reference_type === 'AWB') {
                        const [awb_prefix, awb_no] = innerData.reference_value.split('-');
                        const trData = { ...innerData, awb_prefix, awb_no }
                        const {reference_value, ...rest } = trData
                        setFormData({ ...rest })
                    } else {
                        setFormData(innerData)
                    }
                    setModalPos('NC')
                    setModalShow(true)
                    setEditModal(true)
                } else {
                    toast.error(res.data.response_msg)
                }
                setIsLoading(false)
            },
            onError: (msg) => console.error(msg)
        });
    }

    const handleEdit = (data, fromApi) => {
        setModalPos('IC')
        if (!fromApi) {
            setEditModal(true)
        }
        const orgn = data?.all_routing?.find(s => s.handler_type === 'Origin')
        const dstn = data?.all_routing?.find(s => s.handler_type === 'Destination')
        const sstn = data?.all_routing?.filter(s => s.handler_type === 'Station')
        setFormData({
            ...data,
            all_routing: sstn,
            origin: orgn?.station_code,
            origin_handler_id: orgn?.handler_id,
            origin_handler_feedback_id: orgn?.shipment_routing_id,
            destination: dstn?.station_code,
            destination_handler_id: dstn?.handler_id,
            destination_handler_feedback_id: dstn?.shipment_routing_id,
            ...(data?.master_airway_bill_no === null && {
                avail: true
            }),
        })
        const findOStn = getDestination?.find(st => st.label === orgn?.station_code)
        setOriginHandler(findOStn ? findOStn.address : []);
        setSelectedOriginId(findOStn?.station_id);
        const findOHandler = findOStn?.address.find(h => h.id === orgn?.handler_id)
        setSelectedOriginHandler({
            value: findOHandler?.id,
            label: findOHandler?.handler_name,
            email: findOHandler?.handler_email_id,
            address: findOHandler?.address,
            number: findOHandler?.handler_phone_no,
            id: findOHandler?.id,
            hoid: findOHandler?.handler_org_id,
        });

        const findDStn = getDestination?.find(st => st.label === dstn?.station_code)
        setDestinationHandler(findDStn ? findDStn.address : []);
        setSelectedDestinationId(findDStn?.station_id);
        const findDHandler = findDStn?.address?.find(h => h.id === dstn?.handler_id)
        setSelectedDestinationHandler({
            value: findDHandler?.id,
            label: findDHandler?.handler_name,
            email: findDHandler?.handler_email_id,
            address: findDHandler?.address,
            number: findDHandler?.handler_phone_no,
            id: findDHandler?.id,
            hoid: findDHandler?.handler_org_id,
        });

        // const stn = data?.all_routing.filter(s => s.handler_type === 'Station') || []
        const findSStn = getDestination.find(st => st.label === sstn?.station_code)
        const findShandler = (adrs, id) => {
            const chkStn = adrs?.find(h => h.id === id);
            const trnFH = {
                address: chkStn?.address,
                email: chkStn?.handler_email_id,
                id: chkStn?.id,
                label: chkStn?.handler_name,
                number: chkStn?.handler_phone_no,
                station_id: chkStn?.station_id,
                value: chkStn?.id
            }
            return trnFH;
        }
        const stn = sstn?.map(item => ({
            station: item.station_code,
            station_id: item.station_id,
            stationHandler: getDestination?.find(st => st.label === item?.station_code)?.address || [],
            selectedStationHandler: findShandler(getDestination?.find(st => st.label === item?.station_code)?.address || [], item?.handler_id) ?? null
        }));
        // const stn = data?.all_routing.map(s =>
        //     s.handler_type === 'Station' ?
        //         {
        //             station: s.station_code,
        //             station_id: s.station_id,
        //             stationHandler: [],
        //             selectedStationHandler: null

        //         } : []
        // ) || []

        // setStations([
        //     { station: '', station_id: '', stationHandler: [], selectedStationHandler: null, notifyChecked: false }
        // ]);
        setStations(stn)
        if (!fromApi) {
            const rpStn = data?.all_routing?.find(s => s.is_reported === 1);
            let rpID;
            if (rpStn?.handler_type === 'Origin') {
                rpID = 1
            } else if (rpStn?.handler_type === 'Destination') {
                rpID = 2
            } else {
                const idx = sstn?.findIndex(rs => rs.is_reported === 1);
                rpID = idx !== -1 ? 3 + idx : 3;
            }
            setrReportId(rpID)

            setOnReload(false)
            setModalShow(true)

            if (data?.master_airway_bill_no === null) {
                fetchRecoveryInformation()
            }
        }
    }
    const handleModalClose = () => {
        setModalShow(false)
        setActiveStep(0);
        setFormData(initFData)
        setStations([])

        setOriginHandler([])
        setSelectedOriginId(null)
        setSelectedOriginHandler(null)

        setDestinationHandler([])
        setSelectedDestinationId(null)
        setSelectedDestinationHandler(null)
        setDuplicateData([])
        // setOnReload(false)

        setFiles([])
        setBase64Files([])
        setEditModal(false)
    }

    const steps = [
        { label: (<>Shipment</>), },
        { label: (<>Irregularity</>), },
        { label: (<>Documentation</>), },
    ];
    const validateStep = (stepIndex) => {

        if (stepIndex === 1) {
            if (!formData.avail) {
                if (!formData.master_airway_bill_prefix) {
                    toast.error("Please Add Master Airway Bill Prefix");
                    return;
                }
                if (!formData.master_airway_bill_no) {
                    toast.error("Please Add Master Airway Bill Number");
                    return;
                }
                if (String(formData.master_airway_bill_no).length !== 8) {
                    toast.error("Enter a valid AWB number (8 digits required).");
                    return;
                }
                if (!formData.total_pieces) {
                    toast.error("Please Add Total Pieces");
                    return;
                }
            }
        } else if (stepIndex === 2) {
            if (!formData?.irregularity_type?.length) {
                toast.error("Please Add Irregular Type");
                return;
            }
            if (!formData.pieces_involved) {
                toast.error("Please enter Pieces Involved");
                return;
            }
            if (!formData.weight_involved) {
                toast.error("Please enter Weight Involved");
                return;
            }
            if (!formData.origin) {
                toast.error("Please select Origin");
                return;
            }
            if (!formData.destination) {
                toast.error("Please select Destination");
                return;
            }
            if (!reportId) {
                toast.error("Please select Reported Station");
                return;
            }
        }
        return true;
    }
    const handleStepClick = (stepIndex) => {
        console.log(activeStep, stepIndex);

        if (stepIndex > activeStep) {
            if (validateStep(stepIndex)) {
                setActiveStep(stepIndex);
            }
        } else {
            setActiveStep(stepIndex);
        }
    }
    const stepNext = () => {
        if (validateStep(activeStep + 1)) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    };
    const stepBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    const handleFinish = async () => {
        setPreLoader(true);
        const cleanedFormData = { ...formData };

        if (!formData.avail) {
            delete cleanedFormData.no_master_airway_bill;
        }
        const transformedData = {
            ...cleanedFormData,
            ...(formData.avail && {
                no_master_airway_bill: true
            }),
            all_routing: [
                ...(formData.reported_station
                    ? [{
                        station_name: formData.reported_station,
                        type: 'Reported',
                        handler_id: formData.report_handler_id || '',
                        notify_status: formData.report_notify_status ? 1 : 0
                    }]
                    : []
                ),
                // {
                //     station_name: formData.reported_station,
                //     type: 'Reported',
                //     handler_id: formData.report_handler_id ? formData.report_handler_id : '',
                //     notify_status: formData.report_notify_status == true ? 1 : 0
                // },
                {
                    station_code: formData.origin,
                    handler_type: 'Origin',
                    handler_id: formData.origin_handler_id ? formData.origin_handler_id : '',
                    shipment_routing_id: formData.origin_handler_feedback_id ? formData.origin_handler_feedback_id : '',
                    is_reported: reportId === 1 ? 1 : 0
                },
                ...formData.all_routing,
                {
                    station_code: formData.destination,
                    handler_type: 'Destination',
                    handler_id: formData.destination_handler_id ? formData.destination_handler_id : '',
                    shipment_routing_id: formData.destination_handler_feedback_id ? formData.destination_handler_feedback_id : '',
                    is_reported: reportId === 2 ? 1 : 0
                },

            ],
            // files: formData.files || [] v2/service-recovery/save
        };
        console.log('transformedData', transformedData);
        CallApi({
            endPoint: 'v2/service-recovery/save',
            // payload: formData.service_recovery_id ? formData : transformedData,
            payload: transformedData,
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    toast.success('Record Saved Successfully');
                    if (mainTab === 'CD' || mainTab === 'GD') {
                        setOnReload(true);
                    }
                    handleModalClose()
                    setPreLoader(false);
                    setrReportId(null)
                    // setFiles([])
                    // setBase64Files([])
                    setEditFiles([])
                    // if(formData.service_recovery_id) {
                    //     setReloa(tr)
                    // }
                    if (editModal) {
                        const awbNum = !formData.avail ? `${formData?.master_airway_bill_prefix}-${formData?.master_airway_bill_no}` : ''
                        localStorage.setItem('DetailsTitle', awbNum);
                    }
                } else {
                    setPreLoader(false);
                    toast.error(res.data.response_msg)
                }

            },
            onError: (msg) => console.error(msg)
        });

    }

    // IMAGE UPLOAD START

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);

    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index, id, type) => {
        if (isTopDel) {
            setEditFiles((prevFiles) => {
                const newFiles = [...prevFiles];
                newFiles.splice(index, 1);
                return newFiles;
            });
        } else {
            setFiles((prevFiles) => {
                const newFiles = [...prevFiles];
                newFiles.splice(index, 1);
                return newFiles;
            });
            // base64Files.splice(index, 1);
            setBase64Files((prevBase64Files) => {
                const newBase64Files = [...prevBase64Files];
                newBase64Files.splice(index, 1);

                // Update local storage
                setFormData((prevFormData) => {
                    const newFormData = { ...prevFormData, base64Files: newBase64Files, files: newBase64Files };
                    return newFormData;
                });

                return newBase64Files;
            });
        }

    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];
        let filesProcessed = 0;

        // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
        const existingBase64Files = formData?.base64Files || [];
        const existingFiles = formData?.files || [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                filesWithBase64.push({ file, base64: reader.result, file_name: file.name });
                filesProcessed += 1;
                if (filesProcessed === selectedFiles.length) {
                    const newFiles = filesWithBase64.map((obj) => obj.file);
                    // const newBase64Files = filesWithBase64.map((obj) => obj.base64);
                    const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    const mergedBase64Files = [...existingBase64Files, ...newBase64Files];
                    const mergedFiles = [...existingFiles, ...newBase64Files];
                    // setFiles(newFiles);
                    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
                    setBase64Files(mergedBase64Files);
                    setFormData((prevFormData) => {
                        // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
                        const newFormData = { ...prevFormData, files: mergedFiles };

                        return newFormData;
                    });
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleDeleteImage = (index, id, type) => {
        setIsTopDel(true);
        handleDeleteFile(index);
        // setShowConfirmation(true); need to work
    };
    // IMAGE UPLOAD END

    // Modal Func
    const handleChange = (value) => {
        // console.log(value);

        value = value.replace(/[^\d]/g, ''); // Remove any non-numeric characters
        let formattedValue = '';

        // Add a space after the first 4 digits
        if (value.length > 4) {
            formattedValue += value.substr(0, 4) + ' ';
            value = value.substr(4);
        }

        formattedValue += value;
        return formattedValue.substr(0, 9); // Limit to 9 characters (8 digits + 1 space)
    };
    const handleInputChange = (e) => {
        const { name, value, checked } = e.target;
        if (name === 'master_airway_bill_no') {
            const newValue = handleChange(value);
            setFormData(prev => ({
                ...prev,
                // master_airway_bill_no: newValue
                master_airway_bill_no: value
            }));
            const rawValue = newValue.replace(/\D/g, '');
            if (rawValue.length === 8 && formData.master_airway_bill_prefix?.length === 3) {
                // const fullAWB = `${formData.master_airway_bill_prefix}-${newValue}`;
                const fullAWB = `${formData.master_airway_bill_prefix}-${value}`;
                fetchRecoveryInformation(fullAWB);
            } else {
                setDuplicateData([])
            }
        } else if (name === 'avail') {
            setFormData(prev => ({
                ...prev,
                [name]: checked
            }));
        } else if (name === 'pieces_involved') {
            if (Number(value) > Number(formData?.total_pieces)) {
                if (!formData?.total_weight) {
                    setIsError('Pieces involved cannot exceed total pieces.')
                } else {
                    if (Number(formData?.weight_involved) > Number(formData?.total_weight)) {
                        setIsError('Pieces and weight involved cannot exceed shipment totals.')
                    } else {
                        setIsError('Pieces involved cannot exceed total pieces.')
                    }
                }
            } else {
                if (formData?.total_weight && Number(formData?.weight_involved) > Number(formData?.total_weight)) {
                    setIsError('Weight involved cannot exceed total weight.')
                } else {
                    setIsError(null)
                }
            }
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        } else if (name === 'weight_involved') {
            if (formData?.total_weight) {
                if (!formData?.pieces_involved || Number(formData?.pieces_involved) <= Number(formData?.total_pieces)) {
                    if (Number(value) > Number(formData?.total_weight)) {
                        setIsError('Weight involved cannot exceed total weight.')
                    } else { setIsError(null) }
                } else if (Number(formData?.pieces_involved) > Number(formData?.total_pieces)) {
                    if (Number(value) > Number(formData?.total_weight)) {
                        setIsError('Pieces and weight involved cannot exceed shipment totals.')
                    } else {
                        setIsError('Pieces involved cannot exceed shipment totals.')
                    }
                }
            } else {
                if (Number(formData?.pieces_involved) > Number(formData?.total_pieces)) {
                    setIsError('Pieces involved cannot exceed total pieces.')
                } else {
                    setIsError(null)
                }
            }
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
        // else if (name === 'master_airway_bill_prefix' || name === 'master_airway_bill_no') {
        //     const newValue = handleChange(value);
        //     const rawValue = newValue.replace(/\D/g, '');
        //     if (rawValue.length === 8 && formData.master_airway_bill_prefix?.length === 3) {
        //         const fullAWB = `${formData.master_airway_bill_prefix}-${rawValue}`;
        //         fetchRecoveryInformation(fullAWB);
        //     }
        // }
        else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }

    }
    const fetchRecoveryInformation = (awbNumber, pos) => {
        let PayLoad;
        if (awbNumber) { PayLoad = { master_airway_bill: awbNumber, is_duplicate: 1 } }
        CallApi({
            endPoint: 'v2/service-recovery/recovery-information',
            payload: PayLoad,
            onSuccess: (res) => {
                const innerData = res.data.response_data;
                if (res.data.response_code === 200) {
                    // toast.error(res.data.response_msg);
                    if (awbNumber) {
                        if (innerData?.recovery_list?.length) {
                            setDuplicateData(innerData?.recovery_list)
                            handleEdit(innerData?.recovery_list[0], true)
                        } else {
                            setDuplicateData()
                        }
                    } else {
                        if (pos === 'NC') {
                            const { reference_value, ...rest } = formData
                            setFormData({
                                ...rest,
                                awb_prefix: innerData?.master_airway_bill_prefix,
                                reference_type: 'AWB'
                            });
                        } else {
                            setFormData({ ...initFData, ...innerData });
                        }
                    }

                    // if (innerData?.recovery_list?.length) {
                    //     setDuplicateData(innerData?.recovery_list)
                    //     handleEdit(innerData?.recovery_list[0], true)
                    //     // setFormData(prev => ({
                    //     //     ...prev,
                    //     //     ...innerData?.recovery_list[0]
                    //     // }));
                    // } else {
                    //     // if (innerData?.is_external_data) {
                    //     if (pos === 'NC') {
                    //         const { reference_value, ...rest } = formData
                    //         setFormData({
                    //             ...rest,
                    //             awb_prefix: innerData?.master_airway_bill_prefix,
                    //             reference_type: 'AWB'
                    //         });
                    //     }
                    //     // else {                            
                    //     //     setFormData({...initFData,...innerData});
                    //     // }

                    //     setDuplicateData()
                    //     // }
                    // }
                }

            },
            onError: (msg) => console.error(msg)
        });

        // setFormData(innerData);
        // if (innerData.service_recovery_id) {
        //     setConfData({
        //         header: `AWB Number is already exist`,
        //         subHeader: `Would you like to continue with same AWB number?`,
        //         modalConf: 'C',
        //         closeModal: '',
        //         primaryBtn: 'Continue',
        //         secondaryBtn: 'Create New',
        //     })
        //     setModalConf(true)
        // }
        // if (innerData.origin) {
        //     const selectedDestination = getDestination.find(option => option.value === innerData.origin);
        //     console.log('selectedDestination', selectedDestination);
        //     setOriginHandler(selectedDestination ? selectedDestination.address : []);
        //     setSelectedOriginId(selectedDestination.station_id);

        //     if (selectedDestination && selectedDestination.address.length === 1) {
        //         const autoSelectedHandler = {
        //             value: selectedDestination.address[0].id,
        //             label: selectedDestination.address[0].handler_name,
        //             email: selectedDestination.address[0].handler_email_id,
        //             address: selectedDestination.address[0].address,
        //             number: selectedDestination.address[0].handler_phone_no,
        //             id: selectedDestination.address[0].id,
        //             hoid: selectedDestination.address[0].handler_org_id,
        //         };
        //         setSelectedOriginHandler(autoSelectedHandler);

        //         setFormData(prevFormData => ({
        //             ...prevFormData,
        //             origin_handler_id: selectedDestination.address[0].id
        //         }));
        //     } else {
        //         // Clear handler selection if multiple or no handlers
        //         setSelectedOriginHandler(null);
        //         setFormData(prevFormData => ({
        //             ...prevFormData,
        //             origin_handler_id: ''
        //         }));
        //     }
        // }
        // if (innerData.destination) {
        //     const selectedDestination = getDestination.find(option => option.value === innerData.destination);
        //     setDestinationHandler(selectedDestination ? selectedDestination.address : []);
        //     setSelectedDestinationId(selectedDestination.station_id);

        //     if (selectedDestination && selectedDestination.address.length === 1) {
        //         const autoSelectedHandler = {
        //             value: selectedDestination.address[0].id,
        //             label: selectedDestination.address[0].handler_name,
        //             email: selectedDestination.address[0].handler_email_id,
        //             address: selectedDestination.address[0].address,
        //             number: selectedDestination.address[0].handler_phone_no,
        //             id: selectedDestination.address[0].id,
        //             hoid: selectedDestination.address[0].handler_org_id,
        //         };
        //         setSelectedDestinationHandler(autoSelectedHandler);

        //         setFormData(prevFormData => ({
        //             ...prevFormData,
        //             destination_handler_id: selectedDestination.address[0].id
        //         }));
        //     } else {
        //         // Clear handler selection if multiple or no handlers
        //         setSelectedDestinationHandler(null);
        //         setFormData(prevFormData => ({
        //             ...prevFormData,
        //             destination_handler_id: ''
        //         }));
        //     }
        // }
    };

    const addressModalOpen = (addressType, slst) => {

        // fetchAddressData(addressType, slst)
        if (addressType == 'RH') {
            setInputAddress({
                handler_org_id: selectedReportHandler.hoid,
                address: selectedReportHandler.address,
                handler_email_id: selectedOriginHandler.email,
                // handler_email_id: Array.isArray(selectedReportHandler.email) && selectedReportHandler.email.length === 0 ? [''] : selectedReportHandler.email,
                handler_phone_no: selectedReportHandler.number,
                handler_contact_id: selectedReportHandler?.id,
            });
        } else if (addressType == 'OH') {
            setInputAddress({
                handler_org_id: selectedOriginHandler.hoid,
                address: selectedOriginHandler.address,
                handler_email_id: selectedOriginHandler.email,
                // handler_email_id: Array.isArray(selectedOriginHandler.email) && selectedOriginHandler.email.length === 0 ? [''] : selectedOriginHandler.email,
                handler_phone_no: selectedOriginHandler.number,
                handler_contact_id: selectedOriginHandler?.id,
            });
        } else if (addressType == 'DH') {
            setInputAddress({
                handler_org_id: selectedDestinationHandler.hoid,
                address: selectedDestinationHandler.address,
                handler_email_id: selectedDestinationHandler.email,
                // handler_email_id: Array.isArray(selectedDestinationHandler.email) && selectedDestinationHandler.email.length === 0 ? [''] : selectedDestinationHandler.email,
                handler_phone_no: selectedDestinationHandler.number,
                handler_contact_id: selectedDestinationHandler?.id,
            });
        } else if (addressType == 'SH') {
            setInputAddress({
                handler_org_id: slst?.hoid,
                address: slst?.address,
                handler_email_id: slst?.email,
                // handler_email_id: Array.isArray(slst?.email) && slst?.email.length === 0 ? [''] : slst?.email,
                handler_phone_no: slst?.number,
                handler_contact_id: slst?.id,
            });
        }
        setSelectedStation(slst);
        setAddressFor(addressType);
        setAddressModalShow(true);
    }

    // let repLabel;
    // if (selectedReportId) {
    //     const idMatch = getDestination.find(option => option.station_id == selectedReportId);
    //     repLabel = idMatch.label;
    // }
    let orgLabel;
    if (selectedOriginId) {
        const idMatch = getDestination.find(option => option.station_id == selectedOriginId);
        orgLabel = idMatch.label;
    }
    let destLabel;
    if (selectedDestinationId) {
        const idMatch = getDestination.find(option => option.station_id == selectedDestinationId);
        destLabel = idMatch.label;
    }

    const handleAddressChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox' && name === 'regd') {
            setInputAddress({ ...inputAddress, [name]: checked ? '1' : '0' });
        } else {
            setInputAddress({ ...inputAddress, [name]: value });
        }
        console.log(inputAddress);
    };

    // Email array start
    const handleEmailChange = (index, value) => {
        setInputAddress((prev) => {
            const updatedEmails = [...prev.handler_email_id];
            updatedEmails[index] = value;
            return { ...prev, handler_email_id: updatedEmails };
        });
    };

    const addEmailField = () => {
        setInputAddress((prev) => ({
            ...prev,
            handler_email_id: [...prev.handler_email_id, '']
        }));
    };

    const removeEmailField = (index) => {
        setInputAddress((prev) => ({
            ...prev,
            handler_email_id: prev.handler_email_id.filter((_, i) => i !== index)
        }));
    };
    // Email array end
    const validateAddressData = () => {
        let isValid = true;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Function to validate email
        const validateEmail = (email) => {
            return emailRegex.test(email);
        };
        if (!inputAddress.handler_name) {
            toast.error('Please select a Handler name');
            isValid = false;
        }
        // else if (!validateEmail(inputAddress.handler_email_id)) {
        //     toast.error('Please enter valid email address');
        //     isValid = false;
        // }
        else {
            return isValid;
        }
    };

    const addAddress = async (e) => {
        // console.log('444', inputAddress);
        if (validateAddressData()) {
            e.preventDefault();

            let stationid;
            // if (addressFor == 'report' || addressFor == 'RH') {
            //     stationid = selectedReportId;
            // } else 
            if (addressFor == 'origin' || addressFor == 'OH') {
                stationid = selectedOriginId;
            } else if (addressFor == 'destination' || addressFor == 'DH') {
                stationid = selectedDestinationId;
            } else {
                stationid = selectedStation.station_id
            }
            // const transformedEmails = inputAddress.handler_email_id.filter(email => email.trim() !== '');
            const NewInputAddress = { ...inputAddress, handler_email_id: inputAddress.handler_email_id, station_id: stationid };
            if (NewInputAddress) {
                CallApi({
                    endPoint: SAVEHANDLER,
                    payload: NewInputAddress,
                    onSuccess: (res) => {
                        if (res.data.response_code == 200) {
                            toast.success(res.data.response_msg);
                            const newAddress = res.data.response_data
                                // label: item.port_code,
                                // address: item.address,
                                // station_id: item.station_id
                                ;
                            setAddress(newAddress);
                            // fetchStationData();
                            fetchStationData();
                            // if (addressFor === 'origin' || addressFor === 'destination') {

                            // }
                            if (addressFor == 'origin') {
                                setOriginHandler(prevHandlerNames => [
                                    ...prevHandlerNames,
                                    newAddress
                                ]);
                                // setTimeout(() => {
                                //     if (originHandler.length === 1) {
                                //         setSelectedOriginHandler({ value: newAddress.id, label: newAddress.handler_name })
                                //     }
                                // }, 500);
                            } else if (addressFor == 'destination') {
                                setDestinationHandler(prevHandlerNames => [
                                    ...prevHandlerNames,
                                    newAddress
                                ]);
                            } else if (addressFor == 'OH') {
                                const transformData = {
                                    value: newAddress?.id,
                                    label: newAddress?.handler_name,
                                    email: newAddress?.handler_email_id,
                                    address: newAddress?.address,
                                    number: newAddress?.handler_phone_no,
                                    id: newAddress?.handler_contact_id,
                                    hoid: newAddress?.handler_org_id,
                                }
                                setSelectedOriginHandler(transformData);
                            } else if (addressFor == 'DH') {
                                const transformData = {
                                    value: newAddress?.id,
                                    label: newAddress?.handler_name,
                                    email: newAddress?.handler_email_id,
                                    address: newAddress?.address,
                                    number: newAddress?.handler_phone_no,
                                    id: newAddress?.handler_contact_id,
                                    hoid: newAddress?.handler_org_id,
                                }
                                setSelectedDestinationHandler(transformData);
                            } else if (addressFor == 'SH') {

                                const transformData = {
                                    value: newAddress?.id,
                                    label: newAddress?.handler_name,
                                    email: newAddress?.handler_email_id,
                                    address: newAddress?.address,
                                    number: newAddress?.handler_phone_no,
                                    id: newAddress?.handler_contact_id,
                                    hoid: newAddress?.handler_org_id,
                                    station_id: newAddress?.station_id
                                }
                                // console.log('transformData=1', transformData);
                                // setSelectedStation(transformData);
                                setStations(prevStations =>
                                    prevStations.map(station =>
                                        station.station_id === selectedStation.station_id
                                            ? {
                                                ...station,
                                                selectedStationHandler: transformData, // Update stationHandler with newAddress data
                                                stationHandler: station.stationHandler.map(handler =>
                                                    handler.handler_org_id === newAddress.handler_org_id
                                                        ? { ...handler, ...newAddress } // Replace the matched handler with newAddress
                                                        : handler // Keep the other handlers unchanged
                                                ),
                                            }
                                            : station
                                    )
                                );
                            } else {
                                // const stnHandler = stations?.find(name => name.station === selectedStation.station);

                                setStations(prevStations =>
                                    prevStations.map(station =>
                                        station.station === selectedStation.station
                                            ? {
                                                ...station,
                                                stationHandler: [...station.stationHandler, newAddress] // Update stationHandler with newAddress data
                                            }
                                            : station
                                    )
                                );
                            }
                            setInputAddress({
                                handler_org_id: '', address: '', handler_email_id: '', handler_phone_no: ''
                            });
                            // console.log(address);
                            addressModalClose();
                        } else {
                            toast.error(res.data.response_msg);
                        }
                    },
                    onError: (msg) => console.error(msg)
                });
            }
        }
    }
    // End Address Modal
    // const [selectedStation, setSelectedStation] = useState({});
    const handleAddStation = () => {
        setStations([
            ...stations,
            { station: '', station_id: '', stationHandler: [], selectedStationHandler: null, notifyChecked: false }
        ]);
        setFormData(prevFormData => ({
            ...prevFormData,
            all_routing: [
                ...prevFormData.all_routing,
                { station_name: '', handler_id: '', notify_status: '0' } // Default notify_status to "0"
            ]
        }));
    };
    const handleDeleteStation = (index) => {
        // Remove from stations array
        setStations(prevStations => prevStations.filter((_, idx) => idx !== index));

        // Remove from formData.all_stations
        setFormData(prevFormData => {
            const updatedStations = prevFormData.all_routing.filter((_, idx) => idx !== index);
            return { ...prevFormData, all_routing: updatedStations };
        });
    };

    const handleStationChange = (index, selected, stationHandlers = null, autoSelectedHandler = null) => {
        const selectedDestination = getDestination.find(option => option.value === selected.value);

        setStations(prevStations =>
            prevStations.map((station, idx) =>
                idx === index
                    ? {
                        ...station,
                        station: selected.value,
                        station_id: selectedDestination.station_id,
                        stationHandler: stationHandlers || (selectedDestination ? selectedDestination.address : []),
                        selectedStationHandler: autoSelectedHandler
                    }
                    : station
            )
        );

        setFormData(prevFormData => {
            const updatedAllStations = [...prevFormData.all_routing];
            updatedAllStations[index] = {
                ...updatedAllStations[index],
                station_code: selected.value, // or selected.label if you want the name
                handler_id: autoSelectedHandler ? autoSelectedHandler.value : (updatedAllStations[index]?.handler_id || ''),
                handler_type: 'Station',
            };
            return { ...prevFormData, all_routing: updatedAllStations };
        });
    };

    const handleHandlerChange = (index, selected) => {
        setStations(prevStations =>
            prevStations.map((station, idx) =>
                idx === index
                    ? { ...station, selectedStationHandler: selected }
                    : station
            )
        );

        setFormData(prevFormData => {
            const updatedStations = [...prevFormData.all_routing];
            updatedStations[index] = {
                ...updatedStations[index],
                handler_id: selected.value
            };
            return { ...prevFormData, all_routing: updatedStations };
        });
    };

    // const checkReported = (num) => {
    //     if (num > 2) {
    //         const index = num - 3
    //         console.log('index', index);

    //         setFormData(prevFormData => ({
    //             ...prevFormData,
    //             all_routing: prevFormData.all_routing.map((station, idx) =>
    //                 idx === index
    //                     ? { ...station, is_reported: 1 }
    //                     : { ...station, is_reported: 0 }
    //             )
    //         }));
    //     }
    //     setrReportId(num)
    // }

    const checkReported = (num) => {
        setFormData(prevFormData => {
            let updatedRouting = prevFormData.all_routing.map(station => ({
                ...station,
                is_reported: 0
            }));
            if (num > 2) {
                const index = num - 3;

                updatedRouting = updatedRouting.map((station, idx) =>
                    idx === index
                        ? { ...station, is_reported: 1 }
                        : station
                );
            }
            return {
                ...prevFormData,
                all_routing: updatedRouting
            };
        });

        setrReportId(num);
    };

    // Modal Func
    const handleSearch = (data) => {
        CallApi({
            endPoint: 'v2/service-recovery/duplicate-recovery-information',
            payload: { master_airway_bill: data.name },
            onSuccess: (res) => {
                const innerData = res.data.response_data;
                if (res.data.response_code === 200) {
                    // toast.error(res.data.response_msg);
                    if (innerData?.length > 0) {
                        setDuplicateData(innerData)
                    }
                    setSearchModal(true)
                }

            },
            onError: (msg) => console.error(msg)
        });
    }
    const searchModalClose = () => {
        setSearchModal(false)
        setDuplicateData([])
    }

    const searchDetails = (data, opt) => {
        // console.log('data',data);        
        handleNavClick('', 'OVD', data.name ?? data.master_airway_bill)
        localStorage.setItem('MainTab', 'OV');
        setMainTab('OV')
        const trData = { service_recovery_id: data.id ?? data.service_recovery_id, master_airway_bill: data.name ?? data.master_airway_bill }
        localStorage.setItem('OVDetails', JSON.stringify(trData));
        if (opt) {
            handleModalClose();
            searchModalClose();
        }
        setOnReload(true)
    }
    useEffect(() => {
        if (onReload) {
            setTimeout(() => {
                setOnReload(false)
            }, 20)
        }
    }, [onReload])
    const moreFilter = { multi: multiDropDown, shc: getShc, stn: getDestination }

    const handleExtraHeader = (data) => {
        setExtraHeader(data)
    }
    return (
        <>
            {isLoading ? <><div className='mvt loader-container h-100'><span className='mvt loader' style={{ left: '48%', top: '48%' }}></span></div></> : ''}
            {preLoader &&
                <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
            }
            <div className="d-flex">
                <LeftMenu
                    isIconClosed={isIconClosed}
                    selTab={mainTab}
                    navs={navItems}
                    onNav={handleNavClick}
                    onAdd={addRecord}
                    onSubNav={handleSubNav}
                />
                <div className="mainbody-right">
                    <Header
                        isIconClosed={isIconClosed}
                        oncollapsed={handleCollapse}
                        propData={sendHeader}
                        onSearch={handleSearch}
                        onDetails={searchDetails}
                        extraHeader={extraHeader}
                    />
                    {/* <div className="main-content"> */}
                    {/* {topCards?.length ?
                            <div className="card-bx">
                                {topCards?.map((item, index) => (
                                    <CommonCard icon={iconMap[item.icon]} title={item.title} value={item.value} />
                                ))}
                            </div>
                            : <></>
                        } */}
                    <div className="">
                        {innerPage === '' &&
                            <>
                                {mainTab === 'DB' && <><Dashboard dropData={multiDropDown} onNav={handleNavClick} /></>}
                                {/* {mainTab === 'OV' && <Overview dropData={moreFilter} reloadGrid={onReload} onNav={handleNavClick} />} */}
                                {mainTab === 'CD' && <CriticalDiscrepancies dropData={moreFilter} reloadGrid={onReload} onNav={handleNavClick} onDetails={searchDetails} onSearch={handleSearch} />}
                                {mainTab === 'GD' && <GeneralDiscrepancies dropData={moreFilter} reloadGrid={onReload} onNav={handleNavClick} />}
                                {mainTab === 'NC' && <NonCompliance dropData={moreFilter} reloadGrid={onReload} onNav={handleNavClick} onEdit={ncEdit} />}
                                {mainTab === 'EXP' && <Export dropData={moreFilter} />}
                                {mainTab === 'KC' &&
                                    <>
                                        {subTab === 'CDB' && <Charts getDestination={getDestination} />}
                                        {subTab === 'CG' && <ChartGenerator orgId={multiDropDown?.org_id} />}
                                    </>
                                }
                                {mainTab === 'ST' && <SettingsNew onSnav={settingsNav} />}
                            </>
                        }
                        {innerPage === 'OVD' &&
                            <OvDetails
                                dropData={multiDropDown}
                                onReload={onReload}
                                onRecEdit={handleEdit}
                                stationList={getDestination}
                                stationReload={fetchStationData}
                                sendExtraHeader={handleExtraHeader}
                                onDetails={searchDetails}
                            />
                        }
                    </div>
                </div>
            </div>
            {/* {console.log('addressFor', addressFor)}
        {console.log('originHandler', originHandler)} */}
            <CommonModal
                show={modalShow}
                onHide={handleModalClose}
                // closeClick={handleModalClose}
                title={modalPos === 'NC' && 'Create Non-Compliance'}
                subTitle={modalPos === 'NC' && 'Register a non-compliance record'}
                className={`modal_bgw primary_modal ${modalPos === 'IC' ? 'sr-add-modal' : ''}`}
                footer={
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        {/* <Button variant="secondary" onClick={handleUserModalClose}>
                            Discard
                        </Button>
                        <Button variant="primary" onClick={handleUserModalSave}>
                            Save
                        </Button> */}
                    </div>
                }
            >
                {console.log('formData', formData)}
                {modalPos === 'NC' &&
                    <div className="min-hgt-65 non_compliance">

                        <h6>Reference Type  <span className="red">*</span></h6>
                        <div className='d-flex flex-wrap gap-2 mb-1'>
                            <Button
                                variant="none"
                                className={`rcvryActnBtn ${formData?.reference_type === 'AWB' ? 'active' : ''}`}
                                onClick={() => recAction('AWB')}
                            // disabled={editModal}
                            >
                                AWB No.
                            </Button>
                            <Button
                                variant="none"
                                className={`rcvryActnBtn ${formData?.reference_type === 'ULD' ? 'active' : ''}`}
                                onClick={() => recAction('ULD')}
                            // disabled={editModal}
                            >
                                ULD No.
                            </Button>
                            <Button
                                variant="none"
                                className={`rcvryActnBtn ${formData?.reference_type === 'REF' ? 'active' : ''}`}
                                onClick={() => recAction('REF')}
                            // disabled={editModal}
                            >
                                Reference No.
                            </Button>
                        </div>
                        {formData?.reference_type === 'AWB' &&
                            <>
                                <div className="mb-2 d-flex ">
                                    <div className="w-70">
                                        <Form className=''>
                                            <Form.Label>AWB No. <span className="red">*</span></Form.Label>
                                            <div className='d-flex align-items-center gap-2'>
                                                {/* <Select
                                            options={getOwnerCodes}
                                            value={getOwnerCodes.find(option => option.value === formData.flight_prefix) || ''}
                                            onChange={(selected) => {
                                                recAction('')setFormData(prevFormData => {
                                                    const newFormData = { ...prevFormData, flight_prefix: selected.value };
                                                    return newFormData;
                                                });
                                            }}
                                            labelledBy="Select "
                                            className='multiselect_brd add_shc'
                                        /> */}
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Prefix"
                                                    name='awb_prefix'
                                                    onChange={handleNcChange}
                                                    maxLength='3'
                                                    onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 3); }}
                                                    value={formData?.awb_prefix || ''}
                                                    className='awbnum'
                                                />
                                                <span> - </span>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="AWB No."
                                                    name='awb_no'
                                                    maxLength={8}
                                                    onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                                    onChange={handleNcChange}
                                                    value={formData?.awb_no || ''}
                                                    className='add_hifen'
                                                />
                                            </div>
                                        </Form>
                                    </div>
                                </div>
                                <div className="dividers"></div>
                            </>
                        }
                        {(formData?.reference_type === 'ULD' || formData?.reference_type === 'REF') &&
                            <div className="mb-2 d-flex ">
                                <div className="w-100">
                                    <Form className=''>
                                        <Form.Label>{formData?.reference_type === 'ULD' ? 'ULD' : 'Reference'} No. <span className="red">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder={formData?.reference_type === 'ULD' ? 'ULD No.' : 'Reference No.'}
                                            name='reference_value'
                                            // maxLength={8}
                                            // onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                            onChange={handleNcChange}
                                            value={formData?.reference_value || ''}
                                            className='add_hifen'
                                        />
                                    </Form>
                                </div>
                            </div>
                        }

                        {formData?.reference_type &&
                            <>
                                <div className="d-flex gap-3 mb-1 ">
                                    <Form.Group className="w-50">
                                        <Form.Label>Station <span className="red">*</span></Form.Label>
                                        <Select
                                            options={getDestination}
                                            onChange={(selected) => {
                                                setFormData(prevFormData => ({
                                                    ...prevFormData,
                                                    station: selected.value,
                                                }));
                                            }}
                                            placeholder="Station"
                                            className='autoslct w-100 p-0'
                                            name="station"
                                            value={getDestination.find(option => option.value === formData.station) || ''}
                                        />
                                    </Form.Group>
                                </div>
                                <div className="d-flex gap-3 mb-1">
                                    <div className="w-50">
                                        <Form.Label>Flight No.</Form.Label>
                                        <div className='d-flex align-items-center gap-2'>
                                            <Select
                                                options={getOwnerCodes}
                                                value={getOwnerCodes.find(option => option.value === formData.flight_prefix) || ''}
                                                onChange={(selected) => {
                                                    setFormData(prevFormData => {
                                                        const newFormData = { ...prevFormData, flight_prefix: selected.value };
                                                        return newFormData;
                                                    });
                                                }}
                                                labelledBy="Prefix"
                                                className='multiselect_brd add_shc flight_prefix'
                                                placeholder="Prefix"
                                            />
                                            <span> - </span>
                                            <Form.Control
                                                type="number"
                                                placeholder="Flight No."
                                                name='flight_no'
                                                maxLength={9}
                                                onChange={handleNcChange}
                                                value={formData?.flight_no || ''}
                                                className='flight_no'

                                            />
                                        </div>
                                    </div>

                                    <div className="w-50">
                                        <Form.Label>Flight Date</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name='flight_date'
                                            value={formData.flight_date || ''}
                                            onChange={handleInputChange}
                                            className='total_pic'
                                            placeholder="Flight Date"
                                        />
                                    </div>
                                </div>
                                <div className="d-flex gap-3 mb-1">
                                    <div className="w-50">
                                        <Form.Label>Product Code</Form.Label>
                                        <Select
                                            options={multiDropDown?.product_code}
                                            onChange={(selected) => {
                                                setFormData(prevFormData => {
                                                    const newFormData = { ...prevFormData, product_code: selected.value };
                                                    return newFormData;
                                                });
                                            }}
                                            placeholder="Product Code"
                                            className='autoslct w-50 p-0s w-100'
                                            name="product_code"
                                            value={multiDropDown?.product_code?.find(option => option.value === formData.product_code) || ''}
                                        />
                                    </div>
                                    <div className="w-50">
                                        <Form.Label style={{ width: 'auto' }} className='me-2'>SHC <span></span></Form.Label>
                                        <Select
                                            options={multiDropDown?.shc_code}
                                            value={multiDropDown?.shc_code?.filter(item => formData?.shc_id?.includes(item.value))}
                                            onChange={(selected) => {
                                                const selectedIds = selected.map(item => item.value);
                                                setFormData((prevFormData) => ({
                                                    ...prevFormData,
                                                    shc_id: selectedIds
                                                }));
                                            }}
                                            labelledBy="SHC "
                                            isMulti
                                            className='multiselect_brd add_shc'
                                        />
                                    </div>
                                </div>

                                <div className="dividers"></div>

                                <div className="mb-1 d-flex ">
                                    <div className="w-100">
                                        <Form.Group>
                                            <Form.Label>Type of Error <span className="red">*</span></Form.Label>
                                            <Select
                                                options={errorType}
                                                onChange={(selected) => {
                                                    setFormData(prevFormData => ({
                                                        ...prevFormData,
                                                        type_of_error: selected.value,
                                                    }));
                                                }}
                                                placeholder="Type of Error"
                                                className='autoslct w-100 p-0'
                                                name="type_of_error"
                                                value={errorType?.find(option => option.value === formData?.type_of_error) || ''}
                                            />
                                        </Form.Group>
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <Form.Group>
                                        <Form.Label>Details of Non-Compliance <span className="red">*</span></Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={8}
                                            placeholder="Enter details ..."
                                            value={formData.details_non_compliance || ''}
                                            name='details_non_compliance'
                                            onChange={handleNcChange}
                                            className="remarks_reco"
                                        />
                                    </Form.Group>
                                </div>
                                {/* <div className="mb-1">
                                    <Form.Group>
                                        <Form.Label>Add Attachments</Form.Label>
                                        <div className="upload-wrapper">
                                            <div className='upload-box'>
                                                <div className="upload-content text-center">


                                                    <div className="d-flex align-items-center justify-content-center gap-1">
                                                        <New_upload />
                                                        <span className="">Drag files here or </span>
                                                        <Link variant="contained" className="" onClick={handleBrowseFiles}> click to upload </Link>
                                                    </div>

                                                    <p className="upload_sub">
                                                        JPG, PNG or PDF, file size no more than 25MB
                                                    </p>

                                                    <input
                                                        type="file"
                                                        ref={fileInputRef}
                                                        hidden
                                                        accept="image/png,image/jpeg,application/pdf"
                                                        onChange={handleFileChange}
                                                        multiple
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="remark-files">
                                            {formData?.attachments?.length ? formData?.attachments?.map((file, index) => {
                                                const fileName = file.file_name;
                                                const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                const extension = fileName?.split(".").pop();
                                                return (
                                                    <>
                                                        
                                                        <div key={file.file_name + index}>
                                                            <FontAwesomeIcon icon={faDownload} onClick={() => DownloadImage(file.file_path, file.file_name)} />
                                                            {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 10)}... .${extension}`}
                                                        
                                                        </div>
                                                    </>
                                                )
                                            }) : <></>
                                            }
                                            {files?.map((file, index) => {
                                                const fileName = file.name;
                                                const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                const extension = fileName?.split(".").pop();
                                                return (
                                                    <>
                                                        
                                                        <div key={file.name + index}>
                                                            <FontAwesomeIcon icon={faDownload} />
                                                            {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 10)}... .${extension}`}
                                                            <img src={Trash} onClick={() => handleDeleteFile(index)} alt="delete_icon" />
                                                        </div>
                                                        


                                                    </>
                                                )
                                            })}
                                            
                                        </div>
                                    </Form.Group>
                                </div> */}

                                <div className='d-flex justify-content-between prev_nxt_btn'>
                                    < Button onClick={handleModalClose} variant="contained" className="prev_btn">Cancel</Button>
                                    <Button className='trnext' variant="primary" onClick={saveNc}>Create Non-Compliance</Button>
                                </div>
                            </>
                        }
                    </div>
                }
                {modalPos === 'IC' &&
                    <Row>
                        <Col sm='3' className="recovery_step_dv">
                            <p>Create Recovery Case</p>
                            <Stepper activeStep={activeStep} orientation="vertical" className='recovery_step'>
                                {steps.map(({ label }, index) => (
                                    <Step key={label + index} disabled={index !== activeStep} className={activeStep === index ? 'stepActive' : ''}>
                                        <StepLabel onClick={() => handleStepClick(index)}>{label}</StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </Col>
                        <Col sm='9' className="recovery_details">
                            {activeStep === 0 &&
                                <>
                                    <h4>Shipment Details</h4>
                                    <p>Identify the shipment and provide the core cargo information</p>
                                    <hr />
                                    <div className="">
                                        <Row className="mb-2">
                                            <h4>Shipment Identification</h4>
                                            <Col sm="7">
                                                <Form className=''>
                                                    <Form.Label>AWB No. {!formData.avail && <span className="red">*</span>}</Form.Label>
                                                    <div className='d-flex align-items-center gap-2'>
                                                        {/* <Select
                                                    options={getOwnerCodes}
                                                    value={getOwnerCodes.find(option => option.value === formData.master_airway_bill_prefix) || ''}
                                                    onChange={(selected) => {
                                                        setFormData(prevFormData => {
                                                            const newFormData = { ...prevFormData, master_airway_bill_prefix: selected.value };
                                                            return newFormData;
                                                        });
                                                    }}
                                                    labelledBy="Select "
                                                    className='multiselect_brd add_shc'
                                                /> */}
                                                        <Form.Control
                                                            type="number"
                                                            placeholder="Prefix"
                                                            name='master_airway_bill_prefix'
                                                            onChange={handleInputChange}
                                                            maxLength='3'
                                                            onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 3); }}
                                                            value={formData?.master_airway_bill_prefix || ''}
                                                            className='awbnum'
                                                            disabled={formData.avail}
                                                        />
                                                        <span> - </span>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="AWB No."
                                                            name='master_airway_bill_no'
                                                            maxLength={8}
                                                            onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                                            onChange={handleInputChange}
                                                            value={formData?.master_airway_bill_no || ''}
                                                            className='add_hifen'
                                                            disabled={formData.avail}
                                                        />
                                                    </div>
                                                </Form>
                                            </Col>
                                        </Row>
                                        {(formData?.master_airway_bill_no || '')?.replace(/\D/g, '').length === 0 &&
                                            <div className="not_avl">
                                                <Form.Check
                                                    inline
                                                    type="checkbox"
                                                    id=''
                                                    className=""
                                                    label='AWB number not available'
                                                    checked={formData.avail}
                                                    name='avail'
                                                    // disabled={!isEditing}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                        }
                                        {duplicateData?.length > 0 &&
                                            <div className="duplicate_box mb-2">
                                                <h5>Existing Recovery Records Found <span>{duplicateData?.length}</span></h5>
                                                <ul>
                                                    {duplicateData?.map((entry, index) => (
                                                        <li key={entry?.service_recovery_id + '_' + index} className="existing_item">
                                                            <div className="exist_text">
                                                                <span className="highlight">{entry?.irregularity_type.join(', ')}</span> <span className="me-2">{entry?.reporting_station}</span> <label className={entry?.is_recovery_closed ? 'green_btn' : 'gray_btn'}>{entry?.is_recovery_closed ? 'Closed' : 'Open'}</label>
                                                            </div>
                                                            <div>
                                                                <button className="viewall_btn" onClick={() => searchDetails(entry, 'close')}>View Case<span>
                                                                    <FontAwesomeIcon icon={faAngleRight} /></span>
                                                                </button>

                                                            </div>

                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        }
                                        <Row className="mb-2">
                                            <Col sm="5 pe-1">
                                                <Form.Label>Total Pieces {!formData.avail && <span className="red">*</span>}</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    name='total_pieces'
                                                    value={formData.total_pieces || ''}
                                                    onChange={handleInputChange}
                                                    className='total_pic'
                                                    placeholder="Total Pieces"
                                                />
                                            </Col>

                                            <Col sm="5 ps-2">
                                                <Form.Label  >Total Weight</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    name='total_weight'
                                                    value={formData.total_weight || ''}
                                                    onChange={handleInputChange}
                                                    className='total_pic'
                                                    placeholder="Total Weight"
                                                />
                                            </Col>
                                        </Row>
                                        <hr />

                                        <Row>
                                            <h4>Cargo Information</h4>
                                            <Col sm="5 mb-2 pe-1">
                                                <Form.Label>Nature of goods<span></span></Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Nature of Goods"
                                                    name='nature_of_goods'
                                                    // maxLength={9}
                                                    onChange={handleInputChange}
                                                    value={formData?.nature_of_goods || ''}
                                                    className='add_hifen me-3'

                                                />

                                            </Col>
                                            <Col sm="5 mb-2 ps-2">
                                                <Form.Label style={{ width: 'auto' }} className='me-2'>SHC <span></span></Form.Label>
                                                <Select
                                                    options={multiDropDown?.shc_code}
                                                    value={multiDropDown?.shc_code?.filter(item => formData?.shc_id?.includes(item.value))}
                                                    onChange={(selected) => {
                                                        const selectedIds = selected.map(item => item.value);
                                                        setFormData((prevFormData) => ({
                                                            ...prevFormData,
                                                            shc_id: selectedIds
                                                        }));
                                                    }}
                                                    labelledBy="SHC "
                                                    isMulti
                                                    className='multiselect_brd add_shc'
                                                />
                                            </Col>
                                            <Col sm="5 pe-1">
                                                <Form.Label>Freight Type</Form.Label>
                                                {/* <Form.Control type="text" placeholder="" /> */}
                                                <Select
                                                    options={multiDropDown?.freight_type}
                                                    onChange={(selected) => {
                                                        // const updatedData = { ...formData, flight: selected.value };
                                                        // setFormData(updatedData);
                                                        setFormData(prevFormData => {
                                                            const newFormData = { ...prevFormData, freight_type: selected.value };
                                                            return newFormData;
                                                        });
                                                    }}
                                                    placeholder="Freight Type"
                                                    className='autoslct w-50 p-0s w-100'
                                                    name="flight_type"
                                                    value={multiDropDown?.freight_type?.find(option => option.value === formData.freight_type) || ''}
                                                />

                                            </Col>
                                            <Col sm="5 ps-2">
                                                <Form.Label>Product Code</Form.Label>
                                                {/* <Form.Control
                                                type="text"
                                                name='product_code'
                                                value={formData.product_code || ''}
                                                onChange={handleInputChange}
                                                className='total_pic'
                                                placeholder="Product Code"
                                            /> */}
                                                <Select
                                                    options={multiDropDown?.product_code}
                                                    onChange={(selected) => {
                                                        // const updatedData = { ...formData, flight: selected.value };
                                                        // setFormData(updatedData);
                                                        setFormData(prevFormData => {
                                                            const newFormData = { ...prevFormData, product_code: selected.value };
                                                            return newFormData;
                                                        });
                                                    }}
                                                    placeholder="Product Code"
                                                    className='autoslct w-50 p-0s w-100'
                                                    name="product_code"
                                                    value={multiDropDown?.product_code?.find(option => option.value === formData.product_code) || ''}
                                                />
                                            </Col>
                                        </Row>
                                        <hr />

                                        <Row className="mb-2">
                                            <h4>Parties Involved</h4>
                                            <Col sm="5 mb-2 pe-1">
                                                <Form.Label>Shipper</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name='shipper'
                                                    value={formData.shipper || ''}
                                                    onChange={handleInputChange}
                                                    className='total_pic'
                                                    placeholder="Shipper Name"
                                                />

                                            </Col>
                                            <Col sm="5 mb-2 ps-2">
                                                <Form.Label>Consignee</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name='consignee'
                                                    value={formData.consignee || ''}
                                                    onChange={handleInputChange}
                                                    className='total_pic'
                                                    placeholder="Consignee Name"
                                                />
                                            </Col>
                                            <Col sm="5">
                                                <Form.Label>Agent</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name='agent'
                                                    value={formData.agent || ''}
                                                    onChange={handleInputChange}
                                                    className='total_pic'
                                                    placeholder="Agent Name"
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                </>
                            }
                            {activeStep === 1 &&
                                <>
                                    <h4>Irregularity Information</h4>
                                    <p>Describe the issue, affected cargo, and reporting details.</p>
                                    <hr />
                                    <Row className="mb-2">
                                        <h4>Irregularity Details</h4>
                                        <Col sm='10'>
                                            <Form.Group>
                                                <Form.Label>Irregularity Type <span className="red">*</span></Form.Label>
                                                <Select
                                                    options={multiDropDown?.irregularity_type}
                                                    // value={multiDropDown?.irregularity_type.find(option => option.value === formData.irregularity_type) || ''}
                                                    value={multiDropDown?.irregularity_type?.filter(item => formData?.irregularity_type?.includes(item.value))}
                                                    onChange={(selected) => {
                                                        const selectedIds = selected.map(item => item.value);
                                                        setFormData((prevFormData) => ({
                                                            ...prevFormData,
                                                            irregularity_type: selectedIds
                                                        }));
                                                        // setFormData(prevFormData => {
                                                        //     const newFormData = { ...prevFormData, irregularity_type: selected.value };
                                                        //     return newFormData;
                                                        // });
                                                    }}
                                                    labelledBy="Select "
                                                    placeholder="Irregularity Type"
                                                    isMulti
                                                // className='multiselect_brd add_shc'
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="mb-1">
                                        <Col sm="5 pe-1">
                                            <Form.Label>Pieces Involved <span className="red">*</span></Form.Label>
                                            <Form.Control
                                                type="number"
                                                name='pieces_involved'
                                                value={formData.pieces_involved || ''}
                                                onChange={handleInputChange}
                                                className='total_pic'
                                                placeholder="Pieces Involved"

                                            />
                                        </Col>

                                        <Col sm="5 ps-2">
                                            <Form.Label>Weight Involved <span className="red">*</span></Form.Label>
                                            <Form.Control
                                                type="number"
                                                name='weight_involved'
                                                value={formData.weight_involved || ''}
                                                onChange={handleInputChange}
                                                className='total_pic'
                                                placeholder="Weight Involved"
                                            />
                                        </Col>
                                    </Row>
                                    {isError && <p className="red">{isError}</p>}
                                    <Row className="mb-2">
                                        <Col sm="5 pe-1">
                                            <Form.Label>Flight No.</Form.Label>
                                            <div className='d-flex align-items-center gap-2'>
                                                <Select
                                                    options={getOwnerCodes}
                                                    value={getOwnerCodes.find(option => option.value === formData.flight_prefix) || ''}
                                                    onChange={(selected) => {
                                                        setFormData(prevFormData => {
                                                            const newFormData = { ...prevFormData, flight_prefix: selected.value };
                                                            return newFormData;
                                                        });
                                                    }}
                                                    labelledBy="Prefix"
                                                    className='multiselect_brd add_shc flight_prefix'
                                                    placeholder="Prefix"
                                                />
                                                <span> - </span>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Flight No."
                                                    name='flight_no'
                                                    maxLength={9}
                                                    onChange={handleInputChange}
                                                    value={formData?.flight_no || ''}
                                                    className='add_hifen'

                                                />
                                            </div>
                                        </Col>

                                        <Col sm="5 ps-2">
                                            <Form.Label>Flight Date</Form.Label>
                                            <Form.Control
                                                type="date"
                                                name='flight_date'
                                                value={formData.flight_date || ''}
                                                onChange={handleInputChange}
                                                className='total_pic'
                                                placeholder="Flight Date"
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mb-2">
                                        <Col sm="10">
                                            <Form.Label>Unit Details</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Unit Details"
                                                name='unit_details'
                                                onChange={handleInputChange}
                                                value={formData?.unit_details || ''}
                                                className='add_hifen'

                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mb-2">
                                        <Col sm="10">
                                            <Form.Label>Additional Information</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Additional Information"
                                                name='additional_info'
                                                onChange={handleInputChange}
                                                value={formData?.additional_info || ''}
                                                className='add_hifen'

                                            />
                                        </Col>
                                    </Row>
                                    <hr />
                                    <div className="shpmnt_routing">
                                        <Row className="align-items-baseline">
                                            <h4>Shipment Routing</h4>
                                            <Col md={3} className="pe-0">
                                                <Form.Group>
                                                    <Form.Label>Origin <span className="red">*</span></Form.Label>
                                                    <Select
                                                        options={getDestination}
                                                        onChange={(selected) => {
                                                            const selectedDestination = getDestination.find(option => option.value === selected.value);
                                                            const transHandler = [{ handler_name: 'Select Handler', id: null }, ...selectedDestination.address]
                                                            setOriginHandler(selectedDestination ? selectedDestination.address : []);
                                                            setSelectedOriginId(selectedDestination.station_id);

                                                            // if (selectedDestination && selectedDestination.address.length === 1) {
                                                            const chkDefault = selectedDestination && selectedDestination.address.find(a => a.is_default_handler === 1)
                                                            if (chkDefault) {
                                                                const autoSelectedHandler = {
                                                                    value: chkDefault.id,
                                                                    label: chkDefault.handler_name,
                                                                    email: chkDefault.handler_email_id,
                                                                    address: chkDefault.address,
                                                                    number: chkDefault.handler_phone_no,
                                                                    id: chkDefault.id,
                                                                    hoid: chkDefault.handler_org_id,
                                                                };
                                                                setSelectedOriginHandler(autoSelectedHandler);

                                                                setFormData(prevFormData => ({
                                                                    ...prevFormData,
                                                                    origin: selected.value,
                                                                    origin_handler_id: chkDefault.id
                                                                }));
                                                            } else {
                                                                // Clear handler selection if multiple or no handlers
                                                                setSelectedOriginHandler(null);
                                                                setFormData(prevFormData => ({
                                                                    ...prevFormData,
                                                                    origin: selected.value,
                                                                    origin_handler_id: ''
                                                                }));
                                                            }
                                                        }}
                                                        placeholder="Origin"
                                                        className='autoslct w-100 p-0'
                                                        name="origin"
                                                        value={getDestination.find(option => option.value === formData.origin) || ''}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={5}>
                                                <Form.Group>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <Form.Label>Origin Handler Name</Form.Label>
                                                        {formData.origin ? <Button variant="link" className="p-0 add-btn" onClick={() => addressModalOpen('origin')}>
                                                            <span className="d-flex"><img src={add} />Add</span>
                                                        </Button>
                                                            : ''}
                                                    </div>
                                                    <Select
                                                        options={originHandler?.map(handler => ({
                                                            value: handler?.id,
                                                            label: handler?.handler_name,
                                                            email: handler?.handler_email_id,
                                                            address: handler?.address,
                                                            number: handler?.handler_phone_no,
                                                            id: handler?.id,
                                                            hoid: handler?.handler_org_id,
                                                        }))}
                                                        onChange={(selected) => {

                                                            setSelectedOriginHandler(selected);
                                                            setFormData(prevFormData => {
                                                                const newFormData = { ...prevFormData, origin_handler_id: selected.value };

                                                                return newFormData;
                                                            });
                                                        }}
                                                        placeholder="Handler Name"
                                                        className='autoslct w-100 p-0'
                                                        name="origin_handler_id"
                                                        // value={handlerNames.find(option => option.value === (selectedHandler ? selectedHandler.value : ''))}
                                                        value={selectedOriginHandler ? { value: selectedOriginHandler.value, label: selectedOriginHandler.label } : ''}
                                                        isDisabled={!originHandler.length}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={4}>
                                                <Form.Group>
                                                    <Form.Label>Reporting Station</Form.Label>
                                                    <div>
                                                        <Form.Check
                                                            type="checkbox"
                                                            checked={reportId === 1}
                                                            onChange={() => checkReported(1)}
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        {console.log('st', stations)}
                                        {stations?.map((station, index) => (
                                            <div key={'station_' + index} className="position-relative">
                                                <Form.Group as={Row} className="align-items-baseline"> {/*  my-3 add_station position-relative */}
                                                    <Col sm="3" className='pe-0'>
                                                        <Form.Label>Station</Form.Label>
                                                        <Select
                                                            options={getDestination}
                                                            onChange={(selected) => {
                                                                const selectedStation = getDestination.find(option => option.value === selected.value);
                                                                const chkDefault = selectedStation && selectedStation.address.find(a => a.is_default_handler === 1)
                                                                if (selectedStation && selectedStation.address.length === 1) {
                                                                    const autoSelectedHandler = {
                                                                        value: selectedStation.address[0].id,
                                                                        label: selectedStation.address[0].handler_name,
                                                                        email: selectedStation.address[0].handler_email_id,
                                                                        address: selectedStation.address[0].address,
                                                                        number: selectedStation.address[0].handler_phone_no,
                                                                        id: selectedStation.address[0].id,
                                                                        hoid: selectedStation.address[0].handler_org_id,
                                                                        station_id: selectedStation.address[0].station_id
                                                                    };

                                                                    handleStationChange(index, selected, selectedStation.address, autoSelectedHandler);
                                                                } else {

                                                                    handleStationChange(index, selected, selectedStation ? selectedStation.address : []);
                                                                }
                                                            }}
                                                            placeholder="Station"
                                                            className='autoslct w-100 p-0'
                                                            name={`station-${index}`}
                                                            value={getDestination.find(option => option.value === station.station) || ''}
                                                        />
                                                    </Col>
                                                    <Col sm="5" className='position-relative'>
                                                        <label className="form-label"> Station Handler Name <span></span>
                                                            {station.station ? (
                                                                <Link to='#' onClick={() => addressModalOpen('station', station)} className='raad_adrss me-2'>+ Add</Link>
                                                            ) : ''}
                                                        </label>
                                                        <Select
                                                            options={station.stationHandler.map(handler => ({
                                                                value: handler.id,
                                                                label: handler.handler_name,
                                                                email: handler?.handler_email_id,
                                                                address: handler?.address,
                                                                number: handler?.handler_phone_no,
                                                                id: handler?.id,
                                                                hoid: handler?.handler_org_id,
                                                                station_id: handler?.station_id
                                                            }))}
                                                            onChange={(selected) => handleHandlerChange(index, selected)}
                                                            placeholder="Handler Name"
                                                            className='autoslct w-100 p-0'
                                                            name={`station_handler-${index}`}
                                                            value={station.selectedStationHandler ? { value: station.selectedStationHandler.value, label: station.selectedStationHandler.label } : ''}
                                                            isDisabled={!station.stationHandler.length}
                                                        />
                                                    </Col>
                                                    <Col sm="4" className='align-self-center pe-0'>
                                                        <Form.Group>
                                                            <Form.Label>Reporting Station</Form.Label>
                                                            <div>
                                                                <Form.Check
                                                                    type="checkbox"
                                                                    checked={reportId === 3 + index}
                                                                    onChange={() => checkReported(3 + index)}
                                                                />
                                                            </div>
                                                        </Form.Group>
                                                        {/* {station.selectedDestinationHandler &&
                                                    <>
                                                        {station.selectedDestinationHandler?.email.some((e) => e.trim() !== "") ?
                                                            <><Link to='#' onClick={() => addressModalOpen('SH', station.selectedDestinationHandler)}><img src={MailGreen} /></Link></>
                                                            : <><Link to='#' onClick={() => addressModalOpen('SH', station.selectedDestinationHandler)}><img src={MailRed} /></Link></>
                                                        }
                                                    </>
                                                } */}
                                                    </Col>
                                                    <Link to="#" onClick={() => handleDeleteStation(index)} className='r_trash'>
                                                        <img src={Trash} />
                                                    </Link>
                                                </Form.Group>
                                            </div>
                                        ))}
                                        <Row className="align-items-baseline mb-2">
                                            <Col md={3} className="pe-0">
                                                <Form.Group>
                                                    <Form.Label>Destination <span className="red">*</span></Form.Label>
                                                    <Select
                                                        column sm="8"
                                                        options={getDestination}
                                                        onChange={(selected) => {
                                                            const selectedDestination = getDestination.find(option => option.value === selected.value);
                                                            const transHandler = [{ handler_name: 'Select Handler', id: null }, ...selectedDestination.address]
                                                            setDestinationHandler(selectedDestination ? selectedDestination.address : []);
                                                            setSelectedDestinationId(selectedDestination.station_id);

                                                            // if (selectedDestination && selectedDestination.address.length === 1) {
                                                            const chkDefault = selectedDestination && selectedDestination.address.find(a => a.is_default_handler === 1)
                                                            if (chkDefault) {
                                                                const autoSelectedHandler = {
                                                                    value: chkDefault.id,
                                                                    label: chkDefault.handler_name,
                                                                    email: chkDefault.handler_email_id,
                                                                    address: chkDefault.address,
                                                                    number: chkDefault.handler_phone_no,
                                                                    id: chkDefault.id,
                                                                    hoid: chkDefault.handler_org_id,
                                                                };
                                                                setSelectedDestinationHandler(autoSelectedHandler);

                                                                setFormData(prevFormData => ({
                                                                    ...prevFormData,
                                                                    destination: selected.value,
                                                                    destination_handler_id: chkDefault.id
                                                                }));
                                                            } else {
                                                                // Clear handler selection if multiple or no handlers
                                                                setSelectedDestinationHandler(null);
                                                                setFormData(prevFormData => ({
                                                                    ...prevFormData,
                                                                    destination: selected.value,
                                                                    destination_handler_id: ''
                                                                }));
                                                            }
                                                        }}
                                                        placeholder="Destination"
                                                        className='autoslct w-100 p-0'
                                                        name="destination"
                                                        value={getDestination.find(option => option.value === formData.destination) || ''}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={5}>
                                                <Form.Group>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <Form.Label>Destination Handler Name</Form.Label>
                                                        {formData.destination ? <Button variant="link" className="p-0 add-btn" onClick={() => addressModalOpen('destination')}>
                                                            <span className="d-flex"><img src={add} />Add</span>
                                                        </Button>
                                                            : ''}
                                                    </div>
                                                    <Select
                                                        options={destinationHandler.map(handler => ({
                                                            value: handler?.id,
                                                            label: handler?.handler_name,
                                                            email: handler?.handler_email_id,
                                                            address: handler?.address,
                                                            number: handler?.handler_phone_no,
                                                            id: handler?.id,
                                                            hoid: handler?.handler_org_id,
                                                        }))}
                                                        onChange={(selected) => {
                                                            setSelectedDestinationHandler(selected);
                                                            setFormData(prevFormData => {
                                                                const newFormData = { ...prevFormData, destination_handler_id: selected.value };

                                                                return newFormData;
                                                            });
                                                        }}
                                                        placeholder="Handler Name"
                                                        className='autoslct w-100 p-0'
                                                        name="destination_handler_id"
                                                        // value={handlerNames.find(option => option.value === (selectedHandler ? selectedHandler.value : ''))}
                                                        value={selectedDestinationHandler ? { value: selectedDestinationHandler.value, label: selectedDestinationHandler.label } : ''}
                                                        isDisabled={!destinationHandler.length}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={4}>
                                                <Form.Group>
                                                    <Form.Label>Reporting Station</Form.Label>
                                                    <div>
                                                        <Form.Check
                                                            type="checkbox"
                                                            checked={reportId === 2}
                                                            onChange={() => checkReported(2)}
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <div className="d-flex justify-content-center">
                                            <button className="add_btn mb-1" onClick={handleAddStation}><img src={add} alt="add" />Add Station</button>
                                        </div>

                                    </div>
                                </>
                            }
                            {activeStep === 2 &&
                                <>
                                    <h4>Documentation</h4>
                                    <p>Add supporting files and remarks related to the case.</p>
                                    <hr />
                                    <Row>
                                        <Col md={12} className="mb-1">
                                            <Form.Group>
                                                <Form.Label>Remarks</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={8}
                                                    placeholder="Write your comments here"
                                                    value={formData.remarks || ''}
                                                    name='remarks'
                                                    onChange={handleInputChange}
                                                    className="remarks_reco"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={12}>
                                            <Form.Group>
                                                <Form.Label>Add Attachments</Form.Label>
                                                <div className="upload-wrapper">
                                                    <div className='upload-box'>
                                                        <div className="upload-content text-center">
                                                            <img src={feather_upload_cloud} alt="upload" className="upld_icon" />

                                                            <h6 className="upload-title">
                                                                Select a file or drag and drop here
                                                            </h6>

                                                            <p className="upload-subtitle">
                                                                JPG, PNG or PDF, file size no more than 25MB
                                                            </p>
                                                            <Button
                                                                variant="outline-primary"
                                                                size="sm"
                                                                className="upload-btn"
                                                                onClick={handleBrowseFiles}
                                                            >
                                                                SELECT FILE
                                                            </Button>


                                                            <input
                                                                type="file"
                                                                ref={fileInputRef}
                                                                hidden
                                                                accept="image/png,image/jpeg,application/pdf"
                                                                onChange={handleFileChange}
                                                                multiple
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="remark-files">
                                                    {formData?.attachments?.length ? formData?.attachments?.map((file, index) => {
                                                        const fileName = file.file_name;
                                                        const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                        const extension = fileName?.split(".").pop();
                                                        return (
                                                            <>
                                                                {/* <div key={index} className='img-thumbnail'> */}
                                                                <div key={file.file_name + index}>
                                                                    <FontAwesomeIcon icon={faDownload} onClick={() => DownloadImage(file.file_path, file.file_name)} />
                                                                    {/* {baseName} */}
                                                                    {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 10)}... .${extension}`}
                                                                    {/* <img src={Trash} onClick={() => handleDeleteFile(index)} alt="delete_icon" /> */}
                                                                </div>
                                                            </>
                                                        )
                                                    }) : <></>
                                                    }
                                                    {files?.map((file, index) => {
                                                        const fileName = file.name;
                                                        const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                        const extension = fileName?.split(".").pop();
                                                        return (
                                                            <>
                                                                {/* <div key={index} className='img-thumbnail'> */}
                                                                <div key={file.name + index}>
                                                                    <FontAwesomeIcon icon={faDownload} />
                                                                    {/* {baseName} */}
                                                                    {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 10)}... .${extension}`}
                                                                    <img src={Trash} onClick={() => handleDeleteFile(index)} alt="delete_icon" />
                                                                </div>
                                                                {/* {["jpeg", "jpg", "png", "webp"].includes(file.name.split(".")[file.name.split(".").length - 1]
                                                            ) ? (
                                                                <>
                                                                    <img
                                                                        src={URL.createObjectURL(file)}
                                                                        alt="Preview"
                                                                        style={{
                                                                            maxWidth: "30px",
                                                                            maxHeight: "30px",
                                                                            marginRight: "5px",
                                                                        }}

                                                                    />
                                                                    <span>
                                                                        {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 10)}... .${extension}`}
                                                                    </span>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <span className="d-flex align-items-center">
                                                                        <img src={Docmnt} style={{
                                                                            maxWidth: "30px",
                                                                            maxHeight: "30px",
                                                                            marginRight: "5px",
                                                                        }} />
                                                                        <span>  {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 10)}... .${extension}`}</span>
                                                                    </span>
                                                                </>
                                                            )} */}


                                                                {/* <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button> */}
                                                                {/* </div> */}
                                                            </>
                                                        )
                                                    })}
                                                    {/* <Button variant="">
                                                    <FontAwesomeIcon icon={faDownload} />
                                                    Missing Report
                                                    <img src={delete_icon} alt="delete_icon" />
                                                </Button>

                                                <Button variant="">
                                                    <FontAwesomeIcon icon={faDownload} />
                                                    Damage Overview Report
                                                    <img src={delete_icon} alt="delete_icon" />
                                                </Button> */}
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </>
                            }
                            <div className='d-flex justify-content-between prev_nxt_btn'>
                                {activeStep === 0 ?
                                    <div></div>
                                    :
                                    < Button onClick={stepBack} variant="contained" className="prev_btn">
                                        <FontAwesomeIcon icon={faArrowLeft} /> Previous
                                    </Button>
                                }
                                <Button className='trnext' variant="primary" onClick={activeStep === steps.length - 1 ? handleFinish : stepNext}>

                                    {activeStep === steps.length - 1 ? <><FontAwesomeIcon icon={faSave} /> Save</> : <> Next <FontAwesomeIcon icon={faArrowRight} /></>}
                                </Button>
                            </div>
                        </Col>
                    </Row>
                }
            </CommonModal >

            <Modal show={addressModalShow} onHide={addressModalClose} centered className='modal_bgw primary_modal'>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {addressFor == 'RH' || addressFor == 'OH' || addressFor == 'DH' || addressFor == 'SH' ? 'Edit' : 'Add'} Address - {addressFor == 'origin' || addressFor == 'OH' ? orgLabel : (addressFor == 'destination' || addressFor == 'DH' ? destLabel : getDestination.find(nm => nm.station_id === selectedStation?.station_id)?.label)}
                        <p>Create a new address for this station</p>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <Form.Group className='mb-2'>
                        <Form.Label>Handler Name <span className="red">*</span></Form.Label>
                        {/* <Form.Control type="text" onChange={handleAddressChange} name='handler_name' placeholder="Company Name" /> */}
                        <Form.Control
                            type="text"
                            onChange={(e) => setInputAddress(prevFormData => ({ ...prevFormData, handler_name: e.target.value }))}
                            name='handler_name'
                            placeholder="Handler Name"
                        />
                        {/* {handlerList.length === 0 ?
                            <Form.Control
                                type="text"
                                onChange={(e) => setInputAddress(prevFormData => ({ ...prevFormData, handler_org_id: e.target.value }))}
                                name='handler_org_id'
                                placeholder="Handler Name"
                            />
                            :
                            <Select
                                options={handlerList}
                                onChange={(selected) => {
                                    setInputAddress(prevFormData => {
                                        const newFormData = { ...prevFormData, handler_org_id: selected.value }; // , handler_email_id: selected.email 
                                        return newFormData;
                                    });
                                }}
                                placeholder="Select Handler"
                                // className='select_handler'
                                name='handler_org_id'
                                isDisabled={['OH', 'DH', 'SH'].includes(addressFor)}
                                value={handlerList.find(option => option.value === inputAddress.handler_org_id) || ''}
                            />
                        } */}
                    </Form.Group>

                    <Form.Group className='mb-2'>
                        <Form.Label>Contact Email ID  </Form.Label> {/* <Link to="#" className="raad_adrss" onClick={addEmailField}>+ Add Email</Link> */}
                        <Form.Control type="text" onChange={handleAddressChange} name='handler_email_id' placeholder="E-mail" value={inputAddress.handler_email_id || ''} />
                        {/* {inputAddress?.handler_email_id?.map((email, index) => (
                            <div key={'email_'+index} className="d-flex align-items-center position-relative mb-2">
                                <Form.Control
                                    type="text"
                                    placeholder="E-mail"
                                    value={email}
                                    onChange={(e) => handleEmailChange(index, e.target.value)}
                                    className=""
                                />
                                {inputAddress.handler_email_id.length > 1 && (

                                    <Link to="#" onClick={() => removeEmailField(index)} className="email_del"> <FontAwesomeIcon icon={faCircleXmark} /> </Link>

                                )}
                            </div>
                        ))} */}
                    </Form.Group>

                    <Form.Group className='mb-2'>
                        <Form.Label>Address </Form.Label>
                        <Form.Control type="text" onChange={handleAddressChange} name='address' placeholder="Address" value={inputAddress.address || ''} />
                    </Form.Group>


                    <Form.Group className='mb-2'>
                        <Form.Label>Telephone No</Form.Label>
                        <Form.Control
                            type="number"
                            onChange={handleAddressChange}
                            name='handler_phone_no'
                            onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12); }}
                            placeholder="Number"
                            value={inputAddress.handler_phone_no || ''}
                        />
                    </Form.Group>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={addAddress}  >
                        <SaveIcon /> Save
                        {/* {addressFor == 'OH' || addressFor == 'DH' || addressFor == 'SH' ? 'Update' : 'Add'} Address */}
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* {console.log('duplicateData', duplicateData)} */}
            <CommonModal
                show={searchModal}
                // onHide={handleModalClose}
                onHide={searchModalClose}
                title={`Recovery Records for ${duplicateData?.length && duplicateData[0]?.master_airway_bill}`}
                subTitle={`${duplicateData?.length} recovery records found for this AWB`}
                className='modal_bgw primary_modal modal_width_551'
                footer={
                    <div className='d-flex w-100 justify-content-between'> {/* w-50 mx-auto are_bottom */}
                        <Button
                            variant="contained"
                            onClick={() => {
                                searchModalClose();
                                addRecord('IC');
                                setFormData({
                                    master_airway_bill_prefix: duplicateData[0]?.master_airway_bill.slice(0, 3),
                                    master_airway_bill_no: duplicateData[0]?.awb_no,
                                })
                            }
                            }
                            className="btn-outline"
                        > <AddIcon width={14} /> Create New Case for AWB </Button>
                        <Button variant="secondary" onClick={searchModalClose}> Close </Button>
                    </div>
                }
            >
                <div className="max-hgt-60">
                    {duplicateData?.map((item, index) => (
                        <div className="search_recor_box">
                            <div className="first_part">
                                <ul>
                                    <li>
                                        <span>Case ID </span>
                                        <p className="blue_text">{item.case_number}</p>
                                    </li>
                                    <li>
                                        <span>Irregularity Type </span>
                                        <p>{item.irregularity_type?.join(', ')}</p>
                                    </li>
                                    <li>
                                        <span>Record Status </span>
                                        <label className={item.is_recovery_closed ? 'green_btn' : 'gray_btn'}>
                                            {item.is_recovery_closed ? 'Closed' : 'Open'}
                                        </label>
                                    </li>
                                    <li>
                                        <button className="viewall_btn mt-3" onClick={() => searchDetails(item, 'close')}>View Case<span>
                                            <FontAwesomeIcon icon={faAngleRight} /></span>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            <div className="second_part">
                                <ul>
                                    <li>
                                        <span>Reporting Station </span>
                                        <p>{item.reporting_station}</p>
                                    </li>
                                    <li>
                                        <span>Pieces/Weight Involved </span>
                                        <p>{item.pieces_involved} / {item.weight_involved}</p>
                                    </li>
                                    <li>
                                        <span>Recovery Phase </span>
                                        <p>{item.recovery_phase}</p>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    ))}
                </div>
            </CommonModal>
        </>
    )
}

export default ServiceRecovery